// extracted by mini-css-extract-plugin
module.exports = {"Thumb":"ChapterPlayer_Thumb__2uavb","ThumbZoom":"ChapterPlayer_ThumbZoom__2VgFO"};